module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/other/entity-other.component.html
// module id = 2256
// module chunks = 0